import { render } from "./MemberManager.vue?vue&type=template&id=d0725908"
import script from "./MemberManager.vue?vue&type=script&lang=js"
export * from "./MemberManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__